import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CampDetails from './campDetail';
import {
  getMeetingById,
  cancelMeeting,
  completeMeeting,
  updateCampStatus,
} from 'services/redux/brandActivtion/conductCamp/action';

const mapStateToProps = (state) => ({
  meetingById: state.ConductCampReducer.meetingById,
  cancel: state.baMeetingReducer.cancel,
  complete: state.baMeetingReducer.complete,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getMeetingById,
      cancelMeeting,
      completeMeeting,
      updateCampStatus,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CampDetails);
